import { motion } from 'framer-motion';
import type { ReactNode } from 'react';
import { fadeUp, staggerContainer } from '../lib/motion';

const VIEWPORT = { once: true, margin: '-80px' } as const;

/** 独立元素滚动入场（自带 whileInView） */
export function Reveal({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <motion.div initial="hidden" whileInView="show" viewport={VIEWPORT} variants={fadeUp} className={className}>
      {children}
    </motion.div>
  );
}

/** 容器：包裹多个 <RevealItem> 形成错落入场 */
export function RevealGroup({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <motion.div initial="hidden" whileInView="show" viewport={VIEWPORT} variants={staggerContainer} className={className}>
      {children}
    </motion.div>
  );
}

/** 放在 <RevealGroup> 内部的子项，由父容器统一调度 stagger */
export function RevealItem({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <motion.div variants={fadeUp} className={className}>
      {children}
    </motion.div>
  );
}
